// TopBanner — modern rotating word band with ✦ separators
const WORDS = [
  "Restoration begins with seed",
  "Caring for Country",
  "expert-led stewardship",
  "Building seed enterprises",
  "Provenance intelligence",
  "For future generations",
];

export default function TopBanner() {
  const strip = WORDS.map((w, i) => (
    <span
      key={i}
      className="inline-flex items-center gap-6 font-mono text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-chalk/85"
    >
      <span>{w}</span>
      <span className="text-ochre" aria-hidden="true">✦</span>
    </span>
  ));

  return (
    <div
      className="bg-eucalypt-dark text-chalk py-2.5 overflow-hidden"
      data-testid="top-banner"
    >
      <div className="marquee" style={{ width: "max-content" }}>
        <div className="flex items-center gap-6">{strip}{strip}</div>
        <div className="flex items-center gap-6">{strip}{strip}</div>
      </div>
    </div>
  );
}
